'use client';

import { ELanguage } from '../Utils/constants.js';
import { UTM_SOURCE_MAPPING } from './constants.js';

var isMobile = function () {
    if (typeof window !== 'undefined') {
        return window.innerWidth < 768;
    }
    return false;
};
var getBaseMsUrl = function () {
    var locationUrl = 'https://ms.vietnamworks.com';
    // Make sure it check window on server side
    if (typeof window !== 'undefined') {
        locationUrl = window.location.origin;
    }
    // staging
    if (locationUrl.indexOf('staging.') >= 0) {
        return locationUrl.replace('staging.', 'staging-ms.');
    }
    // release
    if (locationUrl.indexOf('release.') >= 0) {
        return locationUrl.replace('release.', 'release-ms.');
    }
    // production
    if (locationUrl.indexOf('www.vietnamworks.') >= 0) {
        return locationUrl.replace('www.vietnamworks.', 'ms.vietnamworks.');
    }
    if (locationUrl.indexOf('localhost:') >= 0) {
        return 'https://staging-ms.vietnamworks.com';
    }
    return locationUrl;
};
var secureUrl = function () {
    var locationUrl = 'https://secure.vietnamworks.com';
    // Make sure it check window on server side
    if (typeof window !== 'undefined') {
        locationUrl = window.location.origin;
    }
    // staging
    if (locationUrl.indexOf('staging.') >= 0) {
        return locationUrl.replace('staging.', 'staging-secure.');
    }
    // release
    if (locationUrl.indexOf('release.') >= 0) {
        return locationUrl.replace('release.', 'release-secure.');
    }
    // production
    if (locationUrl.indexOf('www.vietnamworks.') >= 0) {
        return locationUrl.replace('www.vietnamworks.', 'secure.vietnamworks.');
    }
    if (locationUrl.indexOf('localhost:') >= 0) {
        return 'https://staging-secure.vietnamworks.com';
    }
    // Only for wowCV
    if (locationUrl.indexOf('wowcv.') >= 0) {
        return locationUrl.replace('wowcv.', 'secure.');
    }
    return locationUrl;
};
/**
 * Get Vietnamworks url base on current location path (Without using APP_MODE)
 *
 * isHaveLocal true then this function will return base url as localhost
 * (This allow for user login cookie can be saved in localhost)
 *
 * @author Thien Tran
 * @since Jun 09, 2023
 * @param isHaveLocal boolean is isHaveLocal or just want link
 * @returns vietnamworks url
 */
var getBaseUrl = function (isHaveLocal) {
    if (isHaveLocal === void 0) { isHaveLocal = true; }
    var locationUrl = 'www.vietnamworks.com';
    // Make sure it check window on server side
    if (typeof window !== 'undefined') {
        locationUrl = window.location.origin;
    }
    // staging
    if (locationUrl.indexOf('staging.') >= 0 || locationUrl.indexOf('staging-wowcv.') >= 0) {
        return 'staging.vietnamworks.com';
    }
    // release
    if (locationUrl.indexOf('release.') >= 0 || locationUrl.indexOf('release-wowcv.') >= 0) {
        return 'release.vietnamworks.com';
    }
    // production
    if (locationUrl.indexOf('www.vietnamworks.') >= 0 || locationUrl.indexOf('wowcv.') >= 0) {
        return 'www.vietnamworks.com';
    }
    // Make sure cookie was saved in localhost if logged in via localhost
    if (locationUrl.indexOf('localhost:') >= 0) {
        return isHaveLocal ? 'localhost' : 'www.vietnamworks.com';
    }
    return locationUrl;
};
var getRegisterUrl = function (langCode, utmTracking) {
    if (utmTracking === void 0) { utmTracking = ''; }
    var langKey = langCode === ELanguage.VI ? 'vi' : 'en';
    var registerLink = "".concat(secureUrl(), "/register/").concat(langKey, "?client_id=3");
    if (utmTracking !== '') {
        registerLink += "&".concat(utmTracking);
    }
    return registerLink;
};
var getForgotPasswordUrl = function (langCode) {
    var langKey = langCode === ELanguage.VI ? 'vi' : 'en';
    return "".concat(secureUrl(), "/password/").concat(langKey, "/reset?client_id=3");
};
var buildUtm = function (pageName) {
    var utmSource = UTM_SOURCE_MAPPING[pageName] || '';
    return "utm_source_navi=".concat(utmSource, "&utm_medium_navi=Header");
};
var getSocialLoginUrl = function (type, langCode, isApply, pageName) {
    // getBaseUrl(false) mean it should return base url without localhost
    var vnwUrl = getBaseUrl(false);
    var loginPath = langCode === ELanguage.VI ? 'dang-nhap' : 'login';
    var loginUrl = "https://".concat(vnwUrl, "/").concat(loginPath, "?type=").concat(type);
    if (typeof window === 'undefined') {
        return loginUrl;
    }
    var locationUrl = window.location.href;
    if (isApply) {
        if (locationUrl.indexOf('?') > 0) {
            locationUrl += '&applyJob=1';
        }
        else {
            locationUrl += '?applyJob=1';
        }
    }
    if (window.location.href.indexOf('.com/logout') >= 1) {
        locationUrl =
            langCode === ELanguage.VI
                ? "https://".concat(vnwUrl, "/quan-ly-nghe-nghiep/tong-quan")
                : "https://".concat(vnwUrl, "/my-career-center/dashboard");
    }
    // Change password page
    if (window.location.href.indexOf('/quan-ly-tai-khoan/thay-mat-khau-thanh-cong') > 0 ||
        window.location.href.indexOf('/account-settings/change-password-success') > 0) {
        locationUrl =
            langCode === ELanguage.VI
                ? "https://".concat(vnwUrl, "/quan-ly-nghe-nghiep/tong-quan")
                : "https://".concat(vnwUrl, "/my-career-center/dashboard");
    }
    // Change email page
    if (window.location.href.indexOf('/quan-ly-tai-khoan/thay-email-thanh-cong') > 0 ||
        window.location.href.indexOf('/account-settings/change-email-success') > 0) {
        locationUrl =
            langCode === ELanguage.VI
                ? "https://".concat(vnwUrl, "/quan-ly-nghe-nghiep/tong-quan")
                : "https://".concat(vnwUrl, "/my-career-center/dashboard");
    }
    // add utm
    if (locationUrl.indexOf('?') > 0) {
        locationUrl += '&' + buildUtm(pageName);
    }
    else {
        locationUrl += '?' + buildUtm(pageName);
    }
    var encodedRedirectUrl = typeof window !== 'undefined' ? encodeURIComponent(locationUrl) : '';
    if (encodedRedirectUrl !== '') {
        loginUrl += "&redirectURL=".concat(encodedRedirectUrl);
    }
    return loginUrl;
};

export { buildUtm, getBaseMsUrl, getBaseUrl, getForgotPasswordUrl, getRegisterUrl, getSocialLoginUrl, isMobile, secureUrl };
//# sourceMappingURL=helper.js.map
